export const INIT_STATE = {
    modalIsOpen: false
}


/** WEBPACK FOOTER **
 ** ./src/common/constants/index.js
 **/